export const SearchNotFoundErrorMessage="Sorry! We Couldn't Find Any Results For Your Search Query, Please Enter Correct Value"
export const MandatoryFieldsErrorMessage="Please Fill All The Mandatory Details!"
export const MandatoryFieldsSelectingErrorMessage="Please Select All The Mandatory Fields!"
export const VehicleMainCodeErrorMessage="Please Select Correct Make Modal Varient!"
export const InterServerError="Internal Server Error Please Try Again Later!"